import { MobileNavBtn } from './styles';
import { FaBars, FaTimes } from 'react-icons/fa';

const NavButton = ({ isPanelOpen, togglePanel, isScrollDown }) => {
  return (
    <MobileNavBtn
      onClick={togglePanel}
      isScrollDown={isScrollDown}
      isPanelOpen={isPanelOpen}
    >
      {isPanelOpen ? <FaTimes /> : <FaBars />}
    </MobileNavBtn>
  );
};

export default NavButton;
